import {
  SelectOption,
  OrderBy,
  updateSelectedAssignee,
  updateSelectedReason,
  updateSelectedMultiReason,
  updateSelectedStatus,
  updateSelectedScenarioType,
  updateOrderBy,
} from './filtersReducer';
import { Dispatch } from 'redux';

export const updateSelectedAssigneeAction = (selected: SelectOption) => (dispatch: Dispatch) => {
  return dispatch(updateSelectedAssignee(selected));
};

export const updateSelectedStatusAction = (selected: SelectOption) => (dispatch: Dispatch) => {
  return dispatch(updateSelectedStatus(selected));
};

export const updateSelectedReasonAction = (selected: SelectOption) => (dispatch: Dispatch) => {
  return dispatch(updateSelectedReason(selected));
};

export const updateSelectedMultiReasonAction = (selected: SelectOption[]) => (dispatch: Dispatch) => {
  return dispatch(updateSelectedMultiReason(selected));
};

export const updateSelectedScenarioTypeAction = (selected: SelectOption) => (dispatch: Dispatch) => {
  return dispatch(updateSelectedScenarioType(selected));
};

export const updateOrderByAction = (order: OrderBy) => (dispatch: Dispatch) => {
  return dispatch(updateOrderBy(order));
};
